import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCompareArrows = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m15.85 39.75-2.025-2 6.075-6.075H4.25V28.8H19.9l-6.05-6.075 2.025-2 9.475 9.5zm16.3-12.5-9.5-9.5 9.5-9.5 2.025 2L28.1 16.3h15.65v2.875H28.1l6.075 6.075z" })
});
export default SvgCompareArrows;
